"use client";

import React from "react";
import comodoSecure from "./logos/comodo-secure.png";
import ssl from "./logos/ssl.png";
import { useTranslation } from "@/hooks/useTranslation";
import LanguageSelector from "../LanguageSelector";
import Link from "next/link";
import Wrapper from "@/components/organisms/Wrapper";
import Image from "next/image";
import "./style.scss";

type LinkType = { slug: string; title: string }[];

const footerLinks: LinkType = [
  {
    slug: "about-us",
    title: "About Us",
  },
  {
    slug: "faq",
    title: "FAQ",
  },
  {
    slug: "policies/terms-and-conditions",
    title: "Terms and Conditions",
  },
  {
    slug: "policies/terms-of-use",
    title: "Terms of Use",
  },
  {
    slug: "policies/cookie-policy",
    title: "Cookie Policy",
  },
  {
    slug: "policies/privacy-policy",
    title: "Privacy Policy",
  },
  {
    slug: "contact",
    title: "Contact",
  },
];

interface FooterNavigationProps {
  language: string;
  hideFooterNavigation?: boolean;
  hideFooterNavigationLogo?: boolean;
  hideLanguageSelector?: boolean;
}

const FooterNavigation = ({
  language,
  hideFooterNavigation,
  hideFooterNavigationLogo,
  hideLanguageSelector,
}: FooterNavigationProps) => {
  const navigationData = footerLinks;
  const { t } = useTranslation("footer");

  return hideFooterNavigation ? null : (
    <div className="footer-container">
      <Wrapper>
        <nav className="footer-navigation">
          {!hideFooterNavigationLogo && (
            <div className="logo-container">
              <Image
                width="48"
                height="48"
                src={ssl}
                alt="ssl logo"
              />
              <Image
                width="64"
                height="40"
                src={comodoSecure}
                alt="comodoSecure logo"
              />
            </div>
          )}
          <LanguageSelector
            language={language}
            hideLanguageSelector={hideLanguageSelector}
          />
          <ul className="footer-navigation-container">
            {navigationData.map((page) =>
              page ? (
                <li
                  key={`li-${page.slug}`}
                  className="footer-navigation-item">
                  <Link
                    className="footer-navigation-link"
                    href={`/${page.slug}`}>
                    {t(page.title)}
                  </Link>
                </li>
              ) : null
            )}
          </ul>
        </nav>
      </Wrapper>
    </div>
  );
};

export default FooterNavigation;
